export default __webpack_public_path__ + "static/media/VE.cf14fd2e.png";